module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "picker-detail expanded"
  }, [(_vm.detail) ? _c('DetailCard', {
    staticClass: "picker-detail-card",
    attrs: {
      "info": _vm.detail,
      "bookmarked": _vm.isBookmarked
    },
    on: {
      "bookmark": function($event) {
        _vm.$emit('bookmark', _vm.entityId)
      },
      "close": _vm.close
    }
  }) : _c('div', {
    staticClass: "picker-loading"
  }, [_c('spinner', {
    attrs: {
      "size": 60,
      "color": "grey"
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4055d57e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4055d57e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DetailView/index.vue
// module id = 849
// module chunks = 0